import { graphql } from '~/gql';

/**
 * Matter list/detail fragment: includes `AttorneyFields` and `ExpertMatterListFields`
 * (nested attorney + per-row expert for cards and filters).
 */
export const MatterFieldsFragment = graphql(`
  fragment MatterFields on Matter {
    id
    title
    caseDescription
    caseNumber
    courtName
    location
    keyDates
    nextDeadline
    travelPlans
    writtenReportNeeded
    status
    closedAt
    attorneyId
    attorney {
      ...AttorneyFields
    }
    createdAt
    updatedAt
    matterExperts {
      id
      expertId
      status
      exitReason
      exitComment
      expert {
        ...ExpertMatterListFields
      }
      retainers {
        ...RetainerFields
      }
    }
  }

  fragment AttorneyFields on Attorney {
    id
    name
    email
  }

  fragment ExpertMatterListFields on Expert {
    id
    name
    email
    professionalSummary
    avatarUrl
  }
`);

export const MattersDocument = graphql(`
  query Matters {
    matters {
      ...MatterFields
    }
  }
`);

export const MatterDetailDocument = graphql(`
  query MatterDetail($id: BigInt!) {
    matter(id: $id) {
      ...MatterFields
    }
  }
`);
